// Mining pool payout addresses, derived from the chain.
//
// GENERATED FILE - do not edit by hand. Refresh with:
//   node scripts/refresh-mining-pools.mjs
//
// Sampled 1008 blocks ending at height 966532, on 2026-09-11.
// 13 addresses accounting for 1004 of them.
//
// Not an attribution. The block reward arrived at these addresses and the
// blocks are public, so each entry carries its own evidence - unlike the
// curated labels, which are what people widely believe. Pools do rotate
// addresses, which is what the sample window and date are for.

export const MINING_POOLS_AS_OF = "2026-09-11";
export const MINING_POOLS_SAMPLE = 1008;
export const MINING_POOLS_TIP = 966532;

export const miningPools = [
  {
    "address": "bc1qwzrryqr3ja8w7hnja2spmkgfdcgvqwp5swz4af4ngsjecfz0w0pqud7k38",
    "pool": "Foundry USA",
    "blocks": 252,
    "share": 25
  },
  {
    "address": "37jKPSmbEGwgfacCr2nayn1wTaqMAbA94Z",
    "pool": "AntPool",
    "blocks": 184,
    "share": 18.3
  },
  {
    "address": "1K6KoYC69NnafWJ7YgtrpwJxBLiijWqwa6",
    "pool": "F2Pool",
    "blocks": 143,
    "share": 14.2
  },
  {
    "address": "1PuJjnF476W3zXfVYmJfGnouzFDAXakkL4",
    "pool": "ViaBTC",
    "blocks": 103,
    "share": 10.2
  },
  {
    "address": "1BM1sAcrfV6d4zPKytzziu4McLQDsFC2Qc",
    "pool": "SpiderPool",
    "blocks": 97,
    "share": 9.6
  },
  {
    "address": "3Eif1JfqeMERRsQHtvGEacNN9hhuvnsfe9",
    "pool": "SECPOOL",
    "blocks": 49,
    "share": 4.9
  },
  {
    "address": "32i1m6gNcSHwiPX9nfTNXVjme9j5DU8y5g",
    "pool": "MARA Pool",
    "blocks": 45,
    "share": 4.5
  },
  {
    "address": "3K9KZZPB8NRwZVP5wNKX4VYhnswrJxpgZ4",
    "pool": "Luxor",
    "blocks": 38,
    "share": 3.8
  },
  {
    "address": "bc1q2824ekxc6ewypfpzv64h69frnx9dx6rsgek6ec",
    "pool": "OCEAN",
    "blocks": 30,
    "share": 3
  },
  {
    "address": "35BpUGMm4Cod9dVWwdTJK1A4RDsCE3zTVC",
    "pool": "Binance Pool",
    "blocks": 23,
    "share": 2.3
  },
  {
    "address": "1CK6KHY6MHgYvmRQ4PAafKYDrg1ejbH1cE",
    "pool": "Braiins Pool",
    "blocks": 17,
    "share": 1.7
  },
  {
    "address": "bc1q85z0lxe86pkcg2fmppfnykat2375s0pnxjx9sc",
    "pool": "NiceHash",
    "blocks": 16,
    "share": 1.6
  },
  {
    "address": "3J1zSHERKN7FgsEjHeTcwG9tYE3GuMWTcM",
    "pool": "BTC.com",
    "blocks": 7,
    "share": 0.7
  }
];

const byAddress = new Map(miningPools.map((pool) => [pool.address, pool]));

export const findMiningPool = (address) => byAddress.get(address);
